import {
	logicalSettings
} from "./logicalSettings.js"

import {
	v1 as UUID
} from "uuid";
import store from '@/store/index'
let wjQuestionTypeArr = store.state.wjQuestionTypeArr // 计分题

let Paper = function() {
	this.title = '<p style="text-align: center;"><span style="font-size: 20px"><strong><span style="color: #10ab97;">问卷标题</span></strong></span></p>' // 项目名称（问卷）
	this.depict = '感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！' // 项目描述
	this.pageCount = 0 // 页码类型总数
	this.quesCount = 0 // 试题类型总数
	this.quesAtive = '' // 当前选中项
	this.endPageType = 0 // 完成的状态 0 正常 1 提前
	this.endPageNormalMsg = '<p style="text-align: center;">您已完成本次问卷，感谢您的帮助与支持</p>' // 正常完成 结束页提示语
	this.endPageAdvanceMsg = '<p style="text-align: center;">不好意思，您不太适合本次调查，谢谢您的参与</p>' // 提前完成 结束页提示语
	this.questionsList = new Array()

	this.cancleEdit = function() {
		for (var i = 0; i < this.questionsList.length; i++) {
			if (this.questionsList[i].isedit == true) {
				this.quesAtive = this.questionsList[i].qid
			}
			this.questionsList[i].isedit = false;
		}
	}
	/**
	 * @description 创建试题
	 * @param {*} qType 试题类型
	 * @param {*} optionNum 选项个数
	 * @param {*} rowsNum 矩阵行个数
	 * @param {*} columnsNum 矩阵列个数
	 */
	this.createQuestion = function(qType, optionNum, rowsNum, columnsNum) {
		var q = new Question()
		q.qid = UUID();
		q.questionsTypeId = qType
		q = logicalSettings(q)
		// 除段落描述、页码以外
		if (wjQuestionTypeArr.indexOf(qType) != -1) {
			q.quesCode = '' // 问题编码
			q.mustanswer = true; //是否必填
			let index = 0
			this.questionsList.forEach((item) => {
				if (wjQuestionTypeArr.indexOf(item.questionsTypeId) != -1) {
					index++
				}
			})
			q.quesIndex = index
			this.quesCount++
		}
		switch (qType) {
			case '2':
				q.format = 5 // 内容限制
				q.inputHeight = '小' // 输入框高度
				q.questionsName = '手机号'
				break;
			case '3':
				q.format = 0 // 内容限制
				q.questionsName = '单行输入框'
				q.maxNum = 500
				q.minNum = 1
				q.cutType = 1 // 单行输入框
				break;
			case '4':
				q.format = 0 // 内容限制
				q.inputHeight = '大' // 输入框高度
				q.questionsName = '多行输入框'
				q.maxNum = 500
				q.minNum = 1
				q.cutType = 2 // 多行输入框
				break;
			case '5':
				q.format = 0 // 内容限制
				q.inputHeight = '小' // 输入框高度
				q.questionsName = '请填写本项内容'
				q.maxNum = 500
				q.minNum = 0
				break;
			case '6':
				q.optionList = []
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.questionsName = '请选择以下图片'
				q.cutType = 7 // 图片单选
				q.maxOptionsNum = 0 // 最多可选几项 0(不限)
				q.minOptionsNum = 0 // 最少可选几项 0(不限)
				break;
			case '8':
				q.createDefaultOption(optionNum)
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.questionsName = '请选择一个选项'
				q.cutType = 3 // 单选
				q.showcolnum = 1 // 选项布局
				q.relation = [{
					id: ''
				}] // 试题关联选项的试题id
				q.associated = [] // 被关联的试题id
				q.groupingOptionList = [] // 分组
				q.scoreOrNot = 0 // 是否开启分值设置
				q.isClosedLoop = 0 // 是否闭环
				break;
			case '9':
				q.createDefaultOption(optionNum)
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.relation = [{
					id: ''
				}] // 试题关联选项的试题id
				q.associated = [] // 被关联的试题id
				q.questionsName = '请选择一个选项'
				break;
			case '10':
				q.createDefaultOption(optionNum)
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.questionsName = '请选择以下选项 (多选)'
				q.cutType = 4 // 多选
				q.showcolnum = 1 // 选项布局
				q.relation = [{
					id: ''
				}] // 试题关联选项的试题id
				q.associated = [] // 被关联的试题id
				q.maxOptionsNum = 0 // 最多可选几项 0(不限)
				q.minOptionsNum = 0 // 最多可选几项 0(不限)
				q.groupingOptionList = [] // 分组
				break;
			case '11':
				q.scoreImg = 'star' // 样式显示
				q.questionsName = '星级评分'
				q.lowestScore = 1 // 最低分
				q.highestScore = 5 // 最高分
				q.score = 0 // 得分
				q.leftPromptText = ''
				q.centerPromptText = ''
				q.rightPromptText = ''
				q.scoreOrNot = 0 // 是否开启分值设置
				q.percentageNum = 1 // 分值百分比
				break;
			case '12':
				q.createDefaultOption(optionNum)
				q.questionsName = '请选择一个选项'
				q.scoreOrNot = 0 // 是否开启分值设置
				q.isClosedLoop = 0 // 是否闭环
				break;
			case '13':
				q.questionsName = '日期选择'
				break;
			case '14':
				q.createDefaultOption(optionNum)
				q.questionsName = '请给以下选项排序'
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.sortsnums = 0 // 仅选出几位
				break;
			case '15':
				q.manualCorrectionPosition = false // 不允许手动修正位置
				q.questionsName = '地址位置'
				break;
			case '16':
				q.choiceRange = 4 // 详细程度
				q.questionsName = '城市选择'
				break;
			case '17':
				q.questionsName = '时间'
				break;
			case '19':
				q.createDefaultOption(optionNum, rowsNum, columnsNum)
				q.cutType = 5 // 矩阵单选
				q.questionsName = '请选择以下选项'
				q.matrixLineRandom = false //「列」随机排列
				q.matrixRankRandom = false //「行」随机排列
				q.lineRankExchange = false // 矩阵行列交换
				q.fillBoxSlide = false // 手机端填写框可滑动出现
				break;
			case '20':
				q.createDefaultOption(optionNum, rowsNum, columnsNum)
				q.cutType = 6 // 矩阵多选
				q.questionsName = '请选择以下选项'
				q.matrixLineRandom = false //「列」随机排列
				q.matrixRankRandom = false //「行」随机排列
				q.lineRankExchange = false // 矩阵行列交换
				q.maxOptionsNum = 0 // 最多可选几项 0(不限)
				q.minOptionsNum = 0 // 最多可选几项 0(不限)
				q.fillBoxSlide = false // 手机端填写框可滑动出现
				break;
			case '21':
				q.createDefaultOption(optionNum, rowsNum, columnsNum)
				q.questionsName = '请给以下各项打分'
				q.highestScore = 5 // 最高分
				q.matrixLineRandom = false //「列」随机排列
				q.matrixRankRandom = false //「行」随机排列
				q.lineRankExchange = false // 矩阵行列交换
				q.fillBoxSlide = false // 手机端填写框可滑动出现
				break;
			case '22':
				q.createDefaultOption(optionNum, rowsNum, columnsNum)
				q.questionsName = '请填写以下内容'
				q.matrixLineRandom = false //「列」随机排列
				q.matrixRankRandom = false //「行」随机排列
				q.lineRankExchange = false // 矩阵行列交换
				q.fillBoxSlide = false // 手机端填写框可滑动出现
				break;
			case '25':
				q.questionsName = '段落标题'
				q.mustanswer = false
				q.quesCode = '' // 问题编码
				break;
			case '26':
				if (this.questionsList.length > 0 && this.questionsList[0].questionsTypeId != '26') {
					var pageQ = new Question()
					pageQ.qid = UUID();
					pageQ.questionsTypeId = qType
					pageQ.pageNumber = 1
					pageQ.minTimeSwitch = false
					pageQ.minTime = 0 // 最短时间
					pageQ.maxTimeSwitch = false
					pageQ.maxTime = 0 // 最长时间
					pageQ.nextBtnText = '下一页'
					pageQ.isedit = false
					pageQ.isShow = true
					pageQ.bindIsShow = true

					this.questionsList.unshift(pageQ)
					this.pageCount++
				}
				let index = 0
				this.questionsList.forEach((item) => {
					if (item.questionsTypeId == '26') {
						index++
					}
				})
				q.pageNumber = index + 1
				q.minTimeSwitch = false
				q.minTime = 0
				q.maxTimeSwitch = false
				q.maxTime = 0
				q.nextBtnText = '下一页'
				q.lastBtnText = '上一页'
				q.lastBtnShow = true // 显示上一页按钮
				this.pageCount++
				break;
			case '33':
				q.maxFilesNum = 1 // 最大上传文件数量
				q.questionsName = '上传文件'
				break;
			case '34':
				q.questionsName = "请填写以下信息";
				q.quesOptionTitle = `姓名________年龄____岁 联系方式___________` // 用于存储横向填空的填空部分
				let arr = q.quesOptionTitle.match(/_[_]+_/g)
				q.optionList = []
				if (arr.length > 0) {
					arr.forEach((info, index) => {
						let obj = {
							oid: UUID(),
							length: info.length,
							labelName: index + 1,
							optionScore: 0,
							format: 0, // 输入框格式
							mustanswer: true,
							maxNum: 500
						}
						q.optionList.push(obj)
					})
				}
				break;
			case '35':
				q.createDefaultOption(optionNum)
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.questionsName = '请填写以下内容'
				break;
			case '36':
				// type 判断是 选择 还是输入框 1选择 2输入
				q.questionsName = '级联题'
				q.optionPlaceholder1 = '请选择'
				q.optionPlaceholder2 = '请选择'
				q.optionPlaceholder3 = '请选择'
				q.optionPlaceholder4 = '请选择'
				q.optionValue = [] //结果存放
				q.optionList = [{
					id: UUID(),
					value: '选项1',
					label: '选项1',
					type: 1,
					children: [{
						id: UUID(),
						value: '选项1-1',
						label: '选项1-1',
						type: 1,
					}]
				}]
				break;
			case '37':
				q.createDefaultOption(optionNum)
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.isLimitSum = true // 限制总和
				q.sum = 100 // 总和
				q.isLimitNum = true // 限制比重最大最小值
				q.minNum = 0 // 最小值
				q.maxNum = 100 // 最大值
				q.questionsName = '请选择以下各项所占的百分比'
				break;
			case '38':
				q.extremumTag = 1 // 极值标签 默认1 满意度
				q.questionsName = '请您对此项目进行评价'
				q.orderSetting = 5 // 量级设置
				q.startNum = 1 // 起始数值
				q.leftText = '非常不满意'
				q.rightText = '非常满意'
				q.displayStyle = 0 // 显示样式 默认1 数字
				q.scoreOrNot = 0 // 是否开启分值设置
				q.percentageNum = 1 // 分值百分比
				break;
			case '39':
				q.createDefaultOption(optionNum)
				q.questionsName = '请填写你的团队成员信息'
				q.matrixLineRandom = false //「行」随机排列
				q.matrixRankRandom = false //「列」随机排列
				q.lineRankExchange = false // 矩阵行列交换
				q.fillBoxSlide = false // 手机端填写框可滑动出现
				break;
		}
		if (this.questionsList.length > 0) {
			let result = false
			this.questionsList.forEach((info, index) => {
				if (this.quesAtive && info.qid == this.quesAtive) {
					result = true
					this.questionsList.splice(index + 1, 0, q)
				}
			})
			if (result == false) {
				this.questionsList.push(q)
			}
		} else {
			this.questionsList.push(q)
		}
	}
	// 删除一个问题
	this.delQuestion = function(qid) {
		for (var i = 0; i < this.questionsList.length; i++) {
			if (qid == this.questionsList[i].qid) {
				this.questionsList.splice(i, 1)
				break;
			}
		}
	}
	// 复制问题
	this.copyQuestion = function(ques, index) {
		let question = JSON.parse(JSON.stringify(ques))
		question.qid = UUID()
		question.bqid = ''
		question.isedit = true
		question = logicalSettings(question)
		this.questionsList.splice(index + 1, 0, question);

	}
	// 初始化逻辑
	this.initlogicalSettings = function(ques) {
		ques = logicalSettings(ques)
	}
}


// 问题类
let Question = function() {
	this.qid = 0; // 试题id
	this.isedit = true // 新添加的问题设置为编辑状态
	this.questionsTypeId = ""; // 试题类型
	this.questionsName = ""; // 试题名称
	this.isShow = true
	this.bindIsShow = true
	this.optionList = new Array();
	this.questionsSonList = new Array();
	/**
	 * 
	 * @param {*} optionNum 选项个数
	 * @param {*} rowsNum 矩阵行个数
	 * @param {*} columnsNum 矩阵列个数
	 */
	this.createDefaultOption = function(optionNum = 2, rowsNum = 2, columnsNum = 2) {
		switch (this.questionsTypeId) {
			case '35':
				for (var i = 0; i < optionNum; i++) {
					let option = new Option()
					option.oid = UUID()
					option.labelName = "填空" + (i + 1)
					option.notAnswer = true // 可不填
					option.format = 0
					option.minNum = 0 // 最多填写
					option.maxNum = 500 // 最少填写
					option.userAnswer = '' // 默认文本
					option.inputHeight = '小'
					option.isDefault = true // 默认添加的选项
					this.optionList.push(option)
				}
				break
			case '37':
				for (var i = 0; i < optionNum; i++) {
					let option = new Option()
					option.oid = UUID()
					option.labelName = "比重" + (i + 1)
					option.userAnswer = 0
					option.isDefault = true // 默认添加的选项
					this.optionList.push(option)
				}
				break
			case '8':
			case '10':
				for (var i = 0; i < optionNum; i++) {
					let option = new Option()
					option.oid = UUID()
					option.labelName = "选项" + (i + 1)
					option.haveInput = false
					option.inputValue = ''
					option.maxNum = 10
					option.isDefault = true // 默认添加的选项
					this.optionList.push(option)
				}
				break
			case '9':
			case '14':
				for (var i = 0; i < optionNum; i++) {
					let option = new Option()
					option.oid = UUID()
					option.labelName = "选项" + (i + 1)
					option.haveInput = false
					option.inputValue = ''
					option.isDefault = true // 默认添加的选项
					this.optionList.push(option)
				}
				break
			case '12':
				let arr = [{
						oid: UUID(),
						labelName: '正确'
					},
					{
						oid: UUID(),
						labelName: '错误'
					}
				]
				this.optionList = arr
				break
			case '19':
				for (var i = 0; i < rowsNum; i++) {
					let questionsSonList = new QuestionsSonList(this.questionsTypeId, columnsNum)
					questionsSonList.SonId = UUID()
					questionsSonList.questionsName = "矩阵行" + (i + 1)
					questionsSonList.isSelected = ''
					questionsSonList.isDefault = true // 默认添加的选项
					if (i == 1) {
						questionsSonList.optionList = this.questionsSonList[0].optionList.map(info => {
							return info
						})
					}
					this.questionsSonList.push(questionsSonList)
				}
				break
			case '20':
				for (var i = 0; i < rowsNum; i++) {
					let questionsSonList = new QuestionsSonList(this.questionsTypeId, columnsNum)
					questionsSonList.SonId = UUID()
					questionsSonList.questionsName = "矩阵行" + (i + 1)
					questionsSonList.isSelected = []
					questionsSonList.isDefault = true // 默认添加的选项
					if (i == 1) {
						questionsSonList.optionList = this.questionsSonList[0].optionList.map(info => {
							return info
						})
					}
					this.questionsSonList.push(questionsSonList)
				}
				break
			case '21':
			case '22':
				for (var i = 0; i < rowsNum; i++) {
					let questionsSonList = new QuestionsSonList(this.questionsTypeId, columnsNum)
					questionsSonList.SonId = UUID()
					questionsSonList.questionsName = "矩阵行" + (i + 1)
					questionsSonList.isDefault = true // 默认添加的选项
					if (i == 1) {
						questionsSonList.optionList = this.questionsSonList[0].optionList.map(info => {
							return info
						})
					}
					this.questionsSonList.push(questionsSonList)
				}
				break
			case '39':
				for (var i = 0; i < optionNum; i++) {
					let questionsSonList = new QuestionsSonList(this.questionsTypeId)
					questionsSonList.SonId = UUID()
					questionsSonList.questionsName = "成员" + (i + 1)
					questionsSonList.isDefault = false // 默认添加的选项
					questionsSonList.type = 1 // 1填空 2下拉 3上传
					questionsSonList.format = '' //验证
					questionsSonList.options = '' //下拉
					questionsSonList.optionName = '选项1;选项2' //下拉
					questionsSonList.fileList= ''//上传文件
					questionsSonList.value= ''//值
					questionsSonList.minNum = 0 // 最少填写
					questionsSonList.maxNum = 200 // 最多填写
					if (i == 1) {
						questionsSonList.optionList = this.questionsSonList[0].optionList.map(info => {
							return info
						})
					}
					this.questionsSonList.push(questionsSonList)
				}
				break
		}
	}
}

let Option = function() {
	this.oid = 0;
	this.labelName = "";
}

/**
 * 生成矩阵列
 * @param {*} questionsTypeId 试题类型
 * @param {*} columnsNum 矩阵列个数
 */
let QuestionsSonList = function(questionsTypeId, columnsNum) { // 行
	this.SonId = 0
	this.optionList = new Array();
	switch (questionsTypeId) {
		case '19':
			for (var i = 0; i < columnsNum; i++) {
				let option = new Option()
				option.oid = UUID()
				option.labelName = "选项" + (i + 1)
				option.haveInput = false
				option.inputValue = ''
				option.format = 0 // 内容限制
				option.isMaxNum = false // 字数限制开关
				option.maxNum = 500 // 字数限制
				option.notAnswer = true // 该空可不填
				option.isDefault = true // 默认添加的选项
				this.optionList.push(option)
			}
			break
		case '20':
			for (var i = 0; i < columnsNum; i++) {
				let option = new Option()
				option.oid = UUID()
				option.labelName = "选项" + (i + 1)
				option.haveInput = false
				option.inputValue = ''
				option.format = 0 // 内容限制
				option.isMaxNum = false // 字数限制开关
				option.maxNum = 500 // 字数限制
				option.notAnswer = true // 该空可不填
				option.isDefault = true // 默认添加的选项
				this.optionList.push(option)
			}
			break
		case '21':
			for (var i = 0; i < columnsNum; i++) {
				let option = new Option()
				option.oid = UUID()
				option.labelName = "打分" + (i + 1)
				option.ratingScore = 0
				option.isDefault = true // 默认添加的选项
				this.optionList.push(option)
			}
			break
		case '22':
			for (var i = 0; i < columnsNum; i++) {
				let option = new Option()
				option.oid = UUID()
				option.labelName = "填空" + (i + 1)
				option.minNum = 0 //最少填写
				option.maxNum = 500 //最多填写
				option.userAnswer = '' // 默认文本
				option.notAnswer = false // 该空可不填
				option.isDefault = true // 默认添加的选项
				this.optionList.push(option)
			}
			break
		case '39':
			for (var i = 0; i < 2; i++) {
				let option = new Option()
				option.oid = UUID()
				option.labelName = "填空" + (i + 1)
				option.type = '1' // 1填空 2下拉 3上传
				option.format = '' //验证
				option.options = [] //下拉
				option.optionName = '选项1;选项2' //下拉
				option.fileList= ''//上传文件
				option.value= ''//值
				option.minNum = 0 // 最少填写
				option.maxNum = 200 // 最多填写
				option.userAnswer = '' // 默认文本
				option.notAnswer = false // 该空可不填
				option.isDefault = true // 默认添加的选项
				option.fileList=[]
				this.optionList.push(option)
			}
			break
	}

}
export default Paper;
